<template>
  <rolling-segment-page />
</template>

<script>
import RollingSegmentPage from '@/modules/audiences/pages/RollingSegmentPage'

export default {
  name: 'RollingSegmentPageCreate',
  components: { RollingSegmentPage }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/RollingSegmentPageCreate.vue